import { FormRenderProps } from 'react-final-form';
import debounce from 'lodash/debounce';
import { EMAIL_KEY_LS } from '../constants';
import { FormFields, FormValues } from '../types';

export const getEnteredEmailValueFromLS = (): string | null => {
  const enteredEmail = sessionStorage.getItem(EMAIL_KEY_LS);
  return enteredEmail || null;
};

export const setEnteredEmailValueToLS = (email: string): void => {
  sessionStorage.setItem(EMAIL_KEY_LS, email);
};

export const clearEnteredEmailValueToLS = (): void => {
  sessionStorage.removeItem(EMAIL_KEY_LS);
};

const debouncedSetEmail = debounce((value: string) => {
  setEnteredEmailValueToLS(value);
}, 300);

export const onChangeEmailHandler = (
  value: string,
  inputId: FormFields,
  renderProps: FormRenderProps<FormValues>
) => {
  renderProps.form.change(inputId, value);

  if (inputId === FormFields.Email) {
    debouncedSetEmail(value);
  }
};
